"use strict";
import { addEvent } from "../addEvent/addEvent";

export function showHideSearchForm() {
  let searchButons = document.getElementsByClassName(
    "header_szukaj__show-form"
  );

  [...searchButons].forEach((element) => {
    let href = "#" + element.getAttribute("data-formid");
    const form = $(href);
    const closeButtons = $(form).find(".close");

    $(form).submit(function () {
      let val = $(this).find("input#fraza").val();
      return val.trim() == "" ? false : true;
    });

    [...closeButtons].forEach((element) => {
      addEvent(element, "click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        $(href).removeClass("show");
      });
    });

    addEvent(element, "click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      $(href).toggleClass("show");
    });
  });
}
